module.exports = __webpack_public_path__ + "images/4e7f2fbb391a1385038b5f3f2d2755c5.ico";